// src/api/auth/authApi.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
//console.log('API_URL:', API_URL); // This should log "http://localhost:5000/api"

export const checkUserByEmail = async (email) => {
  try {
    const response = await axios.get(`${API_URL}/auth/user/${email}`);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null; // Email not found
    }
    console.error('Error in checkUserByEmail:', error.response?.data || error.message);
    throw error;
  }
};

// Function to request OTP for manual registration/login
export const requestOtp = async (email,fullName=null) => {
  try {
    //console.log('Requesting OTP:', { fullName, email });
    // API call to request OTP
    const response = await axios.post(`${API_URL}/auth/request-otp`, { email, fullName });
    // const response = await axios.post(`${API_URL}/auth/request-otp`, { fullName, email });
    //console.log('OTP request successful:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error in requestOtp:', error.response?.data || error.message);
    throw error;
  }
};

// Function to verify the OTP for manual registration/login
export const verifyOtp = async (email, otp, fullName) => {
  try {
    //console.log('Verifying OTP:', { email, otp, fullName });
    const response = await axios.post(`${API_URL}/auth/verify-otp`, { email, otp, fullName });
    //console.log('OTP verification response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error in verifyOtp:', error.response?.data || error.message);
    throw error;
  }
};

// Function to handle Google login
export const googleLogin = async (data) => {
  try {
    //console.log('Google login data:', data);
    // API call to handle Google login
    const response = await axios.post(`${API_URL}/auth/google-login`, data);
    //console.log('Google login successful:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error in googleLogin:', error.response?.data || error.message);
    throw error;
  }
};
